import * as types from "../types/order"

export const addOrderItems = (newOrderItems) => ({
  type: types.ADD_ORDER_ITEMS,
  newOrderItems
})

export const addOrderItem = (newOrderItem) => ({
  type: types.ADD_ORDER_ITEM,
  newOrderItem
})

export const updateOrderItem = (orderItem, orderItemId) => ({
  type: types.UPDATE_ORDER_ITEM,
  orderItem,
  orderItemId
})

export const deleteOrderItem = (orderItemId) => ({
  type: types.DELETE_ORDER_ITEM,
  orderItemId
})

export const deleteAllOrderItems = () => ({
  type: types.DELETE_ALL_ORDER_ITEMS
})

export const setOrderTableNumber = (tableNumber) => ({
  type: types.SET_ORDER_TABLE_NUMBER,
  tableNumber
})

export const clearOrderTableNumber = () => ({
  type: types.CLEAR_ORDER_TABLE_NUMBER
})

export const addComboToOrder = (newCombo) => ({
  type: types.ADD_COMBO_TO_ORDER,
  newCombo
})

export const editComboOrder = (comboIndex, editedCombo) => ({
  type: types.EDIT_COMBO_TO_ORDER,
  comboIndex,
  editedCombo
})

export const deleteComboFromOrder = (comboIndex) => ({
  type: types.DELETE_COMBO_FROM_ORDER,
  comboIndex
})

export const replaceOrder = newOrder => ({
  type: types.REPLACE_ORDER,
  newOrder
})

export const convertOrderItemsToBuyXFreeX = (
  newCombo,
  removeOrderItemIds,
  updateOrderItemsIds
) => ({
  type: types.CONVERT_ORDER_ITEMS_TO_BUY_X_FREE_X,
  newCombo,
  removeOrderItemIds,
  updateOrderItemsIds
})